import { render, staticRenderFns } from "./CSection.vue?vue&type=template&id=65ec6738&scoped=true&"
import script from "./CSection.vue?vue&type=script&lang=js&"
export * from "./CSection.vue?vue&type=script&lang=js&"
import style0 from "./CSection.vue?vue&type=style&index=0&id=65ec6738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec6738",
  null
  
)

export default component.exports